<div class="root-container" tabindex="1" #container >
  <div class="search-container">
    <input type="text" [(ngModel)]="query" maxlength="100" (keydown)="clearSelection()">
    <i class="bi bi-search"></i>
  </div>
  <div class="search-suggestions" [style.height.px]="max_height_px()">
    @for (i of items_filtered(); track $index) {
      <div class="item" (click)="selectItem(i)">{{ i.name }}</div>
    } @empty {
      <div class="item">No items</div>
    }
  </div>
</div>
